/*
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2024-05-24 11:34:07
 * @Description: 
 */
import type { GameHistoryReponseStateType, JoinStateType } from '@/socket/game/dto/index.dto';
import { useAmountMemoryStore } from '~/stores/cansino/amountMemory';

export const useCrashSocket = (rootPath = 'games') => {
    // 👇用户点击了【下注】
    const EMIT_CRASH_BET = (
        data: {
            amount: string; // 金额
            autoStop: number; // 2=
            frontID: number; // 下注时的毫秒数
        },
        callback: any,
    ) => {
        const amountMemory = useAmountMemoryStore();
        if (data.amount) {
            amountMemory.setLastAmount(data.amount);
        }
        socket.emit(`${rootPath}.crash.bet`, data, callback);
    };

    // 👇 用户提现下车
    const EMIT_CRASH_BET_STOP = (
        data: object,
        callback: any,
    ) => {
        socket.emit(`${rootPath}.crash.stop`, data, callback);
    };

    // 👇 报告后台玩家离场（和 EMIT_GAME_EXIT 重复了） 
    // const EMIT_CRASH_EXIT = (
    //     callback: (res: JoinStateType) => any
    // ) => {
    //     socket.emit(`${rootPath}.crash.exit`, {}, callback);
    // };

    // 👇接收：“飞行姿态
    const ON_CRASH_RUNNING = (
        callback: (...args: any[]) => void,
    )=>{
        // 接收数据如下
        // '42["games.crash.fly",{"state":"fly","total":37400,"coef":10.3101}]'
        const api = `${rootPath}.crash.fly`;
        socket.on(api, callback);
        return () => socket.off(api, callback);
    };

    // 👇接收：下注状态
    const ON_CRASH_STATE = (
        callback: (...args: any[]) => void,
    )=>{
        // 接收数据如下
        // 42["games.crash.state",{"name":"BETTING","end":1703821934169}]
        const api = `${rootPath}.crash.state`;
        socket.on(api, callback);
        return () => socket.off(api, callback);
    };
    // 👇接收：用户提现信息
    const ON_CRASH_STOPPED = (
        callback: (...args: any[]) => void,
    )=>{
        // 接收数据如下
        // 42["games.crash.stopped",{"id":25595,"stop":1.345,"total":4600}]
        const api = `${rootPath}.crash.stopped`;
        socket.on(api, callback);
        return () => socket.off(api, callback);
    };
    // 查询某局游戏详情（包含这局游戏所有参与的玩家列表） 
    const EMIT_CRASH_ROUNDINFO = (
        data: {
            roundNum: number, 
        },
        callback: any,
    ) => {
        socket.emit(`${rootPath}.crash.roundInfo`, data, callback);
    };
    

    return {
        EMIT_CRASH_BET,
        EMIT_CRASH_BET_STOP,
        ON_CRASH_RUNNING,
        ON_CRASH_STATE,
        ON_CRASH_STOPPED,
        EMIT_CRASH_ROUNDINFO,
    };
};


// ▼取得一个随机数
// function getRandomInt(min, max) {
//     const step1 = Math.random() * (max - min + 0);
//     return step1 + min;
// }

// const iFirstCrash = aMsg.findIndex(cur => {
//     return cur?.data?.includes(`"state":"crash"`);
// });
// let i01 = 0;
// let iStart = getRandomInt(0, aMsg.length-1);
// let aTheMsg = aMsg.slice(iStart);
// // 👇测试方法 
// const ON_TAKE_ORDERS = async (callback: Function,) => {
//     let previousMS = aTheMsg[0].time;
//     console.log("开始发消息", aTheMsg);
//     while(true){
//         i01++;
//         if (i01 >= aTheMsg.length) {
//             previousMS = aTheMsg[0].time
//             i01 = 0;
//         }
//         const oCur = aTheMsg[i01];
//         let fGapMS = (oCur.time - previousMS) *1000;
//         previousMS = oCur.time;
//         const [sData=''] = aTheMsg[i01].data.match(/\[.+/) || [];
//         const aData = JSON.parse(sData);
//         // if (aData[1].coef > 1) fGapMS = 0;
//         await Sleep(fGapMS * 1);
//         callback({
//             sMsgType: aData[0],
//             ...aData[1],
//         });
//     }
// };